// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Bfne","bigColWidth":"Table_bigColWidth__1CWHk","biggerColWidth":"Table_biggerColWidth__SfOEs","row":"Table_row__1RNim","col":"Table_col__1cgdw"};